import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from "@mui/material";

const DisplayReligions = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [religions, setReligions] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [selected, setSelected] = useState(null);
  const [formData, setFormData] = useState({});

  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const fetchReligions = async () => {
    try {
      const res = await fetch(`${API_URL}/religion`);
      const result = await res.json();
      if (result.success) setReligions(result.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchReligions();
  }, []);

  const handlePageChange = (_, newPage) => setPage(newPage);

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleView = async (item) => {
    setSelected(item);
    setOpenView(true);
  };

  const handleEdit = async (item) => {
    setSelected(item);
    setFormData(item);
    setOpenEdit(true);
  };

  const handleDelete = (item) => {
    setSelected(item);
    setOpenDelete(true);
  };

  const confirmDelete = async () => {
    await fetch(`${API_URL}/religion/religions/${selected.id}`, {
      method: "DELETE",
    });

    setReligions((prev) => prev.filter((r) => r.id !== selected.id));
    setOpenDelete(false);
  };

  const handleUpdate = async () => {
    await fetch(`${API_URL}/religion/religions/${selected.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    fetchReligions();
    setOpenEdit(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Name (Amharic)</TableCell>
              <TableCell>Family</TableCell>
              <TableCell>Region</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {religions
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((r) => (
                <TableRow key={r.id}>
                  <TableCell>{r.sortOrder}</TableCell>
                  <TableCell>{r.name}</TableCell>
                  <TableCell>{r.nameAm}</TableCell>
                  <TableCell>{r.family}</TableCell>
                  <TableCell>{r.region}</TableCell>

                  <TableCell>
                    <Button onClick={() => handleView(r)}>View</Button>
                    <Button onClick={() => handleEdit(r)}>Edit</Button>
                    <Button color="error" onClick={() => handleDelete(r)}>
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={religions.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </TableContainer>

      {/* VIEW */}
      <Dialog open={openView} onClose={() => setOpenView(false)}>
        <DialogTitle>Religion</DialogTitle>
        <DialogContent>
          <Typography>{selected?.name}</Typography>
          <Typography>{selected?.summary}</Typography>
          <Typography>{selected?.description}</Typography>
          <Typography>
            <strong>Founded:</strong> {selected?.founded}
          </Typography>
          <Typography>
            <strong>Founder:</strong> {selected?.founder}
          </Typography>
          <Typography>
            <strong>Founder (Amharic):</strong> {selected?.founderAm}
          </Typography>
          <Typography>
            <strong>Adherents:</strong> {selected?.adherents}
          </Typography>
        </DialogContent>
      </Dialog>

      {/* EDIT */}
      <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth>
        <DialogTitle>Edit Religion</DialogTitle>
        <DialogContent>
          <TextField
            name="name"
            value={formData.name || ""}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            name="summary"
            value={formData.summary || ""}
            onChange={handleChange}
            fullWidth
            multiline
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEdit(false)}>Cancel</Button>
          <Button onClick={handleUpdate} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* DELETE */}
      <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
        <DialogTitle>Delete Religion?</DialogTitle>
        <DialogActions>
          <Button onClick={() => setOpenDelete(false)}>Cancel</Button>
          <Button color="error" onClick={confirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DisplayReligions;
